import trialPeriodWebp from './trialPeriod.webp';
import trialPeriodJpg1x from './trialPeriod@1x.jpg';
import trialPeriodJpg2x from './trialPeriod@2x.jpg';

export const trialPeriodSources = [
  trialPeriodWebp,
  trialPeriodJpg2x,
  trialPeriodJpg1x,
];
